import * as React from 'react'
import { Box, Typography } from '@mui/material'
import { formatPriceSymbol } from "@ui-seeker/utils"

import { NotAllowedBlock } from '@components'


export default function pricesColumn(name, label) {
	return {
		name: name, label: label,
		options: {
			filter: false,
			customBodyRowRenderLite: (value, { currency }) => <Box sx={{ textAlign: 'center' }}>
				{!!value && <Typography>{formatPriceSymbol(value, currency)}</Typography>}
				{!value && <NotAllowedBlock />}
			</Box>
		}
	}
}